import { AppLogo } from 'assets/icon_by_config/AppLogo';
import React from 'react';
// styles
import styled from 'styled-components';

const OnTruckLogo = ({ className, ...props }) => {
  return <AppLogo {...props} className={className} />;
};

export default styled(OnTruckLogo)``;
